export default __webpack_public_path__ + "static/media/volume.b4c09c2c.png";